import React from 'react'
import Layout from 'Components/Layout'
import PageHead from 'Components/PageHead'
import Button from 'Components/Button'
import WhatsAppIcon from 'Svgs/WhatsAppIcon'
import Link from 'next/link'
import FeaturePoint from 'Components/page-components/pricing/FeaturePoint'
import FAQ from 'Components/page-components/pricing/FAQPoint'
import PricingPlanCard from 'Components/page-components/pricing/PricingPlanCard'

const PricingPage = () => (
  <div>
    <PageHead
      title="Ylurn • Pricing"
      description="Find out about Ylurn's simple and transparent pricing. Check out subscription plans suited for you."
    />
    <div className="max-w-screen-xl my-0 mx-auto p-3 sm:pt-5 sm:pb-20">
      <section id="pricing">
        <h3 className="text-5xl text-center my-7 sm:mt-14 sm:mb-5">Pricing</h3>
        <h5 align="center" className="text-2xl mb-4 text-gray-600">
          Simple, transparent and predictable pricing.
          <br />
          Unlimited courses & unlimited students on all plans.
        </h5>
        <br />
        <br />
        <br />
        <div className="m-auto max-w-5xl">
          <div className="grid grid-cols-3 gap-8">
            <div className="col-span-3 md:col-span-1">
              <PricingPlanCard
                name="Starter"
                pricing="Free"
                cta="START FOR FREE"
                included={[
                  'All course features',
                  'Free website domain',
                  '0% transaction fees',
                  'Instant payouts',
                  'Email / chat support',
                  'YouTube video lectures',
                ]}
                notIncluded={[
                  'File video lectures',
                  'Connect your website',
                  'Branded mobile apps',
                  'Priority phone support',
                  'Marketing Tools',
                  'Connect payment gateway',
                  'Get your own app',
                ]}
              />
            </div>
            <div className="col-span-3 md:col-span-1">
              <PricingPlanCard
                name="Basic"
                pricing="₹999/month"
                cta="START FREE TRIAL"
                included={[
                  'All course features',
                  'Free website domain',
                  '0% transaction fees',
                  'Instant payouts',
                  'Email / chat support',
                  'YouTube video lectures',
                  'File video lectures',
                  'Connect your website',
                  'Branded mobile apps',
                  'Connect payment gateway',
                ]}
                notIncluded={[
                  'Priority phone support',
                  'Marketing Tools',
                  'Get your own app',
                ]}
              />
            </div>
            <div className="col-span-3 md:col-span-1">
              <PricingPlanCard
                name="Pro"
                pricing="₹1999/month"
                cta="START FREE TRIAL"
                included={[
                  'All course features',
                  'Free website domain',
                  '0% transaction fees',
                  'Instant payouts',
                  'Email / chat support',
                  'YouTube video lectures',
                  'File video lectures',
                  'Connect your website',
                  'Branded mobile apps',
                  'Connect payment gateway',
                  'Priority phone support',
                  'Marketing Tools',
                  'Get your own app',
                ]}
                notIncluded={[]}
              />
            </div>
          </div>
        </div>
        <div>
          <div
            className="rounded-lg my-24 mx-auto border border-gray-200 shadow-lg p-4"
            style={{ maxWidth: '600px' }}
          >
            <p className="text-2xl mb-2 text-blue-600">
              Pricing doesn&apos;t fit your requirement?
            </p>
            <p className="text-lg text-gray-700">
              You can message us on WhatsApp -&nbsp;
              <a
                className="text-blue-700 cursor-pointer"
                href="https://wa.me/917397272218"
                target="_blank"
                rel="noopener noreferrer"
              >
                7397272218
                <WhatsAppIcon
                  style={{
                    verticalAlign: 'middle',
                    margin: '0 5px',
                    width: '30px',
                    height: '30px',
                  }}
                />
              </a>
              for your custom pricing plans. You can also fill up&nbsp;
              <Link href="/pricing?modal=contactUs">
                <a className="text-blue-600">this form</a>
              </Link>
              &nbsp;to have a sales expert contact you.
            </p>
          </div>
        </div>
        <div>
          <p className="text-4xl text-center text-gray-700 mt-32 mb-16">FAQs</p>
          <div className="grid grid-cols-2 gap-6">
            <div className="col-span-2 md:col-span-1">
              <FAQ
                question="What is bandwidth and how is it calculated?"
                answer="Bandwidth is the total data used across all your students. For example, if you upload a 200MB video lecture and it is viewed by 5 students, it will count as 200MB x 5 = 1 GB bandwidth usage."
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <FAQ
                question="What if I exceed the bandwidth limit?"
                answer="If you exceed the included bandwidth for your plan, you can purchase extra bandwidth at the cost of ₹10/GB or switch to a bigger basicPlan."
              />
            </div>
          </div>
        </div>
        <div>
          <p className="text-center text-4xl mt-32 mb-8">
            Included in all plans
          </p>
          <div className="grid grid-cols-3 gap-6">
            <div className="col-span-3 md:col-span-1">
              <FeaturePoint text="Live lectures" />
              <FeaturePoint text="Video lecture upload" />
              <FeaturePoint text="File upload" />
              <FeaturePoint text="Unlimited courses" />
              <FeaturePoint text="SMS notifications" />
              <FeaturePoint text="Email notifications" />
              <FeaturePoint text="App notifications" />
              <FeaturePoint text="Payment gateway" />
            </div>
            <div className="col-span-3 md:col-span-1">
              <FeaturePoint text="Landing page builder" />
              <FeaturePoint text="Digital content library" />
              <FeaturePoint text="Student management" />
              <FeaturePoint text="Appearance customisation" />
              <FeaturePoint text="Discussion forum" />
              <FeaturePoint text="Unlimited students" />
              <FeaturePoint text="Announcements" />
              <FeaturePoint text="Marketing tools" />
            </div>
            <div className="col-span-3 md:col-span-1">
              <FeaturePoint text="Online tests" />
              <FeaturePoint text="Test analysis" />
              <FeaturePoint text="Chat and comments" />
              <FeaturePoint text="Private notes" />
              <FeaturePoint text="Coupon/discount codes" />
              <FeaturePoint text="Invite-only courses" />
              <FeaturePoint text="Free courses" />
              <FeaturePoint text="Student performance" />
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Link href="institute/signup">
              <Button
                variant="contained"
                className="text-xl text-white tracking-widest font-semibold bg-green-500 my-16"
                size="large"
              >
                GET STARTED
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  </div>
)

export default Layout(PricingPage, {
  sidebarVariant: 'LANDING',
  isFooterPresent: true,
  fullWidth: true,
})
